import PropTypes from 'prop-types'
import React, { useState } from "react"
//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table } from "reactstrap"
import ApiRest from '../../../ayudas/apiRest'
import _valid from '../../../validations'
import { MDBBtn } from 'mdbreact';
import ModalPassword from '../../../components/ModalPersonalizado/ModalPassword'

const Perfil = props => {
  const [menu, setMenu] = useState(false)
  const apiRest = new ApiRest(props);
  const [modal, setModal] = useState(false)

  function usuario() {
    let usuario = apiRest.getLS('du');

    return usuario;
  }

  function seleccionarEmpresa(empresa) {
    apiRest.asignarEmpresa('idEmpresa', empresa);
  }

  function Administrador() {
    if (apiRest.getRol()) { apiRest.asignarEmpresa('idEmpresa', null) }
  }

  function password() {
    setModal(!modal)
    console.log(modal)
  }

  return (

    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >

          {_valid(usuario().first_name) ? <i className="fa fa-user"></i> : ''}
          <span className="d-none d-xl-inline-block ms-1 fw-medium font-size-15">
            {_valid(usuario().first_name) ? usuario().first_name + ' ' + usuario().last_name : 'Este Usuario No Tiene Un Colaborador Asociado'}
          </span>{" "}
          <i className="uil-angle-down d-none d-xl-inline-block font-size-15"></i>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">

          {
            usuario().usuario_empresas.map(empresa =>
              <DropdownItem tag="a" href="#" onClick={() => seleccionarEmpresa(empresa)}>
                <i className="fas fa-city"></i>{' '}
                <span>{props.t(empresa.nombre)}</span>
              </DropdownItem>
            )
          }

          {
            apiRest.getRol() ?
              <DropdownItem tag="a" href="#" onClick={() => Administrador()}>
                <i className="fas fa-city"></i>{' '}
                <span>{props.t("Administrador")}</span>
              </DropdownItem>
              : ''
          }

          <DropdownItem tag="a" href="#" onClick={() => password()}>
            <i className="fas fa-key"></i>{' '}
            <span>{props.t("Cambiar Contraseña")}</span>
          </DropdownItem>

          <DropdownItem tag="a" href="/logout">
            <i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"></i>
            <span>{props.t("Salir")}</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      { modal == true ? 
        <ModalPassword estadoModal={true}/> : ''
      }
    </React.Fragment>


  )
}

Perfil.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Perfil))
)
